module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Erlinsbach_AG-de820a19ad6701d834d958a77f9c497c.svg";